class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      // {
      //   id: 'cart-icon-bubble',
      //   section: 'cart-icon-bubble',
      //   selector: '.shopify-section'
      // },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch((error) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};


const cartOpenButton = document.getElementById('cart-button-open')
const cartOpenMobileButton = document.getElementById('cart-button-mobile-open')
const cartCloseButton = document.getElementById('cart-button-close')
const cartOverlayContainer = document.getElementById('cart-overlay-container')
const cartOverlay = document.getElementById('cart-overlay')
const cartBubble = document.getElementById('cart-bubble-detail')

const cartProductsContainer = document.getElementById('cart-products-container')
const cartEmpty = document.getElementById('cart-empty')
const cartFooter = document.getElementById('cart-footer')
const cartSubtotal = document.getElementById('cart-subtotal')
const cartSubmit = document.getElementById('cart-submit')
const loader = document.getElementById('loader')

const openCartOverlay = async () => {
  // New plugin cart
  if (window.AMP_API) {
    window.AMP_API.OPEN_CART()
    const result = await fetch(window.Shopify.routes.root + 'cart.json')
    const data = await result.json()

    setTimeout(async () => {
      await checkItemInCart()
    }, 1500)

    // console.log(data)
    if (data.items.length === 0) {
      const newSubmitButton = document.querySelector('.amp-cart__footer-checkout-button')
      if (newSubmitButton) {
        newSubmitButton.disabled = true
      }
    }

    return
  }

  // // Old lugin cart
  // if(window.upcartOpenCart) {
  //   window.upcartOpenCart()
  //   return
  // }

  // Custom cart
  const isMobile = window.matchMedia('(max-width: 768px)').matches
  const translateValue = isMobile ? 100 : 50

  cartOverlayContainer.classList.remove('d-none')

  cartOverlayContainer.animate([
    { opacity: 0 },
    { opacity: 1 }
  ], {
    duration: 200,
    fill: 'forwards'
  })

  cartOverlay.animate([
    { transform: `translateX(${translateValue}vw)` },
    { transform: 'translateX(0vw)' }
  ], {
    duration: 200,
    delay: 200,
    fill: 'forwards'
  })
}
const closeCartOverlay = () => {
  // New plugin cart
  if (window.AMP_API) {
    window.AMP_API.CLOSE_CART()
    return
  }

  // // Old plugin cart
  // if (window.upcartCloseCart) {
  //   window.upcartCloseCart()
  //   return
  // }

  // Custom cart
  const isMobile = window.matchMedia('(max-width: 768px)').matches
  const translateValue = isMobile ? 100 : 50

  cartOverlay.animate([
    { transform: 'translateX(0vw)' },
    { transform: `translateX(${translateValue}vw)` }
  ], {
    duration: 200,
    fill: 'forwards'
  })

  cartOverlayContainer.animate([
    { opacity: 1 },
    { opacity: 0 }
  ], {
    duration: 200,
    delay: 200,
    fill: 'forwards'
  })

  setTimeout(() => {
    cartOverlayContainer.classList.add('d-none')
  }, 200)
}

cartOpenButton.addEventListener('click', openCartOverlay)
cartOpenMobileButton.addEventListener('click', openCartOverlay)
cartCloseButton.addEventListener('click', closeCartOverlay)
cartSubmit.addEventListener('click', () => {
  closeCartOverlay()
  window.location.href = "/checkout"

  setTimeout(() => {
    loader.classList.remove('d-none')

    loader.animate([
      { opacity: 0 },
      { opacity: 1 }
    ], {
      duration: 200,
      fill: 'forwards'
    })
  }, 300)

  setTimeout(() => {
    loader.animate([
      { opacity: 1 },
      { opacity: 0 }
    ], {
      duration: 200,
      fill: 'forwards'
    })

    setTimeout(() => {
      loader.classList.add('d-none')
    }, 300)
  }, 5000)
})

const getCart = async () => {
  const result = await fetch(window.Shopify.routes.root + 'cart.json')
  const data = await result.json()

  data.items.forEach((item) => {
    setCartItems(item, data.items_subtotal_price)
  })
}

const getQuantityCart = async () => {
  const result = await fetch(window.Shopify.routes.root + 'cart.json')
  const data = await result.json()

  return {
    count: data.item_count,
    items: data.items,
    subtotal: data.items_subtotal_price
  }
}

const setCartItems = async ({ id, key, final_line_price, quantity }, subtotal) => {
  const item = document.getElementById(`cart-item-${id}`)
  const itemPrice = document.querySelector(`#cart-item-${id} .Cart-Item__Price`)
  const itemStock = document.querySelector(`#cart-item-${id} .Cart-Item__Stock`)
  const quantityInput = document.querySelector(`#cart-item-${id} .Cart-Item__Quantity`)
  const plusQuantityButton = document.querySelector(`#cart-item-${id} .Cart-Item__Button--Plus`)
  const minusQuantityButton = document.querySelector(`#cart-item-${id} .Cart-Item__Button--Minus`)
  const removeButton = document.querySelector(`#cart-item-${id} .Cart-Item__Button--Remove`)

  itemPrice.innerHTML = normalizePrice(final_line_price)
  quantityInput.value = quantity

  if (subtotal) {
    cartSubtotal.innerHTML = !subtotal.toString().includes('.') ? normalizePrice(subtotal) : subtotal
  }

  const stock = itemStock.value

  quantityInput.addEventListener('change', async (e) => {
    const currentQuantity = Number(e.target.value) > stock ? stock : e.target.value

    // console.log(e.target.value)
    if (Number(e.target.value) <= 0) {
      quantityInput.value = 1
    }
    // console.log(quantityInput.value)

    if (Number(e.target.value) > stock) {
      quantityInput.value = stock
    }

    const { subtotal, price, quantity } = await updateCartItem(key, quantityInput.value)

    itemPrice.innerHTML = `${price}`
    cartSubtotal.innerHTML = `${subtotal}`

    changeStateButtons(plusQuantityButton, minusQuantityButton, quantity, stock)
  })

  plusQuantityButton.addEventListener('click', async () => {
    const result = await fetch(window.Shopify.routes.root + 'cart.json')
    const cart = await result.json()

    const currentItem = cart.items.find(item => item.key === key)
    const newQuantity = currentItem.quantity + 1

    const { subtotal, price, quantity } = await updateCartItem(key, newQuantity)

    itemPrice.innerHTML = `${price}`
    cartSubtotal.innerHTML = `${subtotal}`
    quantityInput.value = quantity

    changeStateButtons(plusQuantityButton, minusQuantityButton, quantity, stock)
  })

  minusQuantityButton.addEventListener('click', async () => {
    const result = await fetch(window.Shopify.routes.root + 'cart.json')
    const cart = await result.json()

    const currentItem = cart.items.find(item => item.key === key)

    if (currentItem.quantity == 1) {
      return
    }

    const newQuantity = currentItem.quantity - 1

    const { subtotal, price, quantity } = await updateCartItem(key, newQuantity)

    itemPrice.innerHTML = `${price}`
    cartSubtotal.innerHTML = `${subtotal}`
    quantityInput.value = quantity

    changeStateButtons(plusQuantityButton, minusQuantityButton, quantity, stock)
  })

  removeButton.addEventListener('click', async () => {
    const { item_count, items_subtotal_price } = await removeCartItem(key)

    item.remove()
    cartSubtotal.innerHTML = `${normalizePrice(items_subtotal_price)}`
    cartBubble.classList.remove('d-none')
    cartBubble.innerHTML = cartBubble.innerHTML + item_count

    if (item_count === 0) {
      cartFooter.classList.add('d-none')
      cartEmpty.classList.remove('d-none')
      cartBubble.classList.add('d-none')
    }
  })

  // Disabled button
  changeStateButtons(plusQuantityButton, minusQuantityButton, quantity, stock)
}

const addCartItem = async (id, quantity, cartQuantity, stock) => {
  // console.log('ID: ' + id)
  // console.log('Quantity: ' + quantity)
  // console.log('Cart Quantity: ' + cartQuantity)
  // console.log('Stock: ' + stock)
  const newSubmitButton = document.querySelector('.amp-cart__footer-checkout-button')
  newSubmitButton.disabled = false

  const result = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      items: [
        {
          id,
          quantity
        }
      ]
    })
  })

  const { items } = await result.json()

  // console.log(items)

  items.forEach(({ id, title, image, quantity, final_line_price }) => {
    const buttonMinusTags = quantity > 1
      ? `<button class="Cart-Item__Button--Minus">
        <i data-lucide="minus"></i>
      </button>`
      : `<button class="Cart-Item__Button--Minus Cart-Item__Button--Disabled" title="" disabled>
        <i data-lucide="minus"></i>
      </button>`

    const buttonPlusTags = quantity < stock
      ? `<button class="Cart-Item__Button--Plus">
          <i data-lucide="plus"></i>
        </button>`
      : `<button class="Cart-Item__Button--Plus Cart-Item__Button--Disabled" title="Stock Limit" disabled>
          <i data-lucide="plus"></i>
        </button>`

    const itemTags = `
      <img class="Cart-Item__Image" src="${image}" alt="${title}" title="${title}">

      <div class="Cart-Item__Content">
        <header class="w-100 d-flex justify-content-between align-items-center">
          <h4 class="Cart-Item__Title text-3 fw-semibold m-0">
            ${title}
          </h4>

          <button class="Cart-Item__Button--Remove text-2" title="Remove ${title}">
            <i data-lucide="trash-2"></i>
          </button>
        </header>

        <div class="w-100 d-flex flex-column align-items-end gap-3">
          <h3 class="Cart-Item__Price text-2 fw-semibold">
            ${normalizePrice(final_line_price)}
          </h3>

          <input class="Cart-Item__Stock" type="hidden" name="" value="${stock}"">

          <div class="Cart-Item__Quantity-Container">
            ${buttonMinusTags}
            <input class="Cart-Item__Quantity" type="number" name="quantity" value="${quantity}">
            ${buttonPlusTags}
          </div>
        </div>
      </div>
    `

    const item = document.createElement('div')
    item.classList.add('Cart-Item')
    item.classList.add('pb-3')
    item.id = `cart-item-${id}`
    item.innerHTML = itemTags

    cartProductsContainer.appendChild(item)
  })

  cartBubble.classList.remove('d-none')
  cartBubble.innerHTML = cartQuantity + items[0].quantity
  cartEmpty.classList.add('d-none')
  cartFooter.classList.remove('d-none')

  return {
    items,
    itemPrice: items[0].final_line_price
  }
}

const updateCartItem = async (id, quantity, currentCuantity) => {
  const finalQuantity = currentCuantity ? quantity + currentCuantity : quantity
  const result = await fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: id,
      quantity: finalQuantity
    })
  })

  const data = await result.json()
  // console.log(data)

  // Get subtotal price
  const subtotal = normalizePrice(data.items_subtotal_price)

  // Get item price
  const item = data.items.find(item => item.key == id || item.id == id)

  const price = normalizePrice(item.final_line_price)
  const newQuantity = item.quantity

  // Update cart total count
  const totalCount = data.item_count
  cartBubble.innerHTML = totalCount

  return {
    data,
    subtotal,
    price,
    quantity: newQuantity
  }
}

const removeCartItem = async (id) => {
  const result = await fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id,
      quantity: 0
    })
  })

  const data = await result.json()

  // console.log(data)

  return data
}

const normalizePrice = (price) => {
  const subtotalString = price.toString()
  const subtotalArray = subtotalString.split('')
  subtotalArray.splice(-2, 0, '.')
  const pointIndex = subtotalArray.indexOf('.')
  if (pointIndex > 3) {
    subtotalArray.splice(-6, 0, ',')
  }
  if (!subtotalArray.includes('$')) {
    subtotalArray.unshift('$')
  }

  const subtotal = subtotalArray.join('')

  return subtotal
}

const changeStateButtons = (plusButton, minusButton, quantity, stock) => {
  if (quantity == stock) {
    plusButton.classList.add('Cart-Item__Button--Disabled')
    plusButton.setAttribute('disabled', true)
    plusButton.setAttribute('title', 'Stock Limit')
  } else {
    plusButton.classList.remove('Cart-Item__Button--Disabled')
    plusButton.removeAttribute('disabled')
    plusButton.removeAttribute('title')
  }

  if (quantity == 1) {
    minusButton.classList.add('Cart-Item__Button--Disabled')
    minusButton.setAttribute('disabled', true)
    minusButton.setAttribute('title', 'Stock Limit')
  } else {
    minusButton.classList.remove('Cart-Item__Button--Disabled')
    minusButton.removeAttribute('disabled')
    minusButton.removeAttribute('title')
  }
}

getCart()
